export const displayTime = (time: number): string => {
  const timeInSec = time / 1000;
  if (timeInSec < 60 ) { // poniżej minuty
    return '00:' + timeInSec.toString();
  }
  if (timeInSec < 60 * 60) { // poniżej godziny
    const minutes = Math.floor(timeInSec / 60);
    const seconds = timeInSec - (minutes*60);
    return ('0' + minutes.toString()).slice(-2) + ':' + seconds.toFixed(3).toString();
  }
  return time.toString();
}

export function a11yProps(index: number) {
  return {
    id: `tab-${index}`,
    'aria-controls': `tabpanel-${index}`,
  };
}